import { gql } from '@apollo/client';

export const FETCH_MODEL_CONFIGURATIONS = gql`
    query fetchModelConfigurations {
        facility {
            models {
                configurations {
                    calmet {
                        __typename
                        id
                        name
                    }
                    calpuff {
                        __typename
                        id
                        name
                    }
                    trajectories {
                        type
                        id
                        name
                    }
                }
            }
        }
    }
`;
